// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"3018":"4ae657ee","3195":"99d0889b","5160":"cdc0cef9"}[chunkId] + "." + {"3018":"3abdc4300f78a091","3195":"045b8ceeb4cc510c","5160":"5c1d364684fe179a"}[chunkId] + ".js";
};